import axios from "axios"

export const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URI,
    // headers: {
    //     "Content-Type": "application/json",
    // },
})

// Ajouter le token dans l’en-tête Authorization
apiClient.interceptors.request.use((config) => {
    const raw = localStorage.getItem("accessToken");
    const token = raw ? JSON.parse(raw) : null;

    if (token) {
        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`,
        }
    }
    return config
})